import { z } from 'zod'
import { oc } from '@orpc/contract'

export const consentGet = oc
  .route({ method: 'GET', path: '/v2/consent' })
  // patientId is only honored for Practitioner (provider-portal) callers; patient
  // callers are locked to their own id server-side (see consent-get.handler.ts).
  .input(z.object({ patientId: z.string().optional() }))
  .output(
    z.object({
      items: z.array(
        z.object({
          organizationId: z.string(),
          organizationName: z.string().optional(),
          status: z.string().optional(),
          granted: z.boolean(),
          // FHIR DocumentReference (the signed consent doc, when present).
          document: z.any().optional(),
          documentUrl: z.string().optional(),
        }),
      ),
    }),
  )
